import { createRouter, createWebHistory } from 'vue-router'
// 標記工具
import Login from '@/components/HomeLogin.vue'
import HomePage from '@/components/HomePage.vue'
import ImageChecker from '@/components/ImageChecker.vue'
import UserManage from '@/components/UserManage.vue'
import { isLoggedIn, userPermissions } from '@/auth'
// 生圖網站
import ImageGeneration from '@/components/ImageGeneration.vue';
import ImageUpscale from '@/components/ImageUpscale.vue';
import ImageInpainting from "@/components/ImageInpainting.vue";
import TimePortrait from '@/components/TimePortrait.vue';
// 使用者條款
import UserTerms from '@/components/UserTerms.vue';
// 時代肖像QRCode下載頁面
import DownloadImage from '@/components/DownloadImage.vue';
// 時代肖像幻燈片頁面
import TimePortraitSlideshow from '@/components/TimePortraitSlideshow.vue';
// 時代肖像列印頁面
import TimePortraitPrint from '@/components/TimePortraitPrint.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
    // 移除 meta: { requiresAuth: true }，讓首頁可以在未登入時訪問
  },
  { path: '/login', name: 'Login', component: Login },
  {
    path: '/check',
    name: 'ImageChecker',
    component: ImageChecker,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'UserManage',
    component: UserManage,
    meta: { requiresAuth: true, requiresManage: true }
  },
  {
    path: '/generation',
    name: 'ImageGeneration',
    component: ImageGeneration,
    meta: { requiresAuth: true }
  },
  {
    path: '/upscale',
    name: 'ImageUpscale',
    component: ImageUpscale,
    meta: { requiresAuth: true }
  },
  {
    path: '/inpainting',
    name: 'ImageInpainting',
    component: ImageInpainting,
    meta: { requiresAuth: true }
  },
  {
    path: '/timePortrait',
    name: 'TimePortrait',
    component: TimePortrait,
    meta: { requiresAuth: true }
  },
  {
    path: '/tp-show-20260428-7f3c91e89d44c8e9b1a7c9f0e5b8',
    name: 'TimePortraitSlideshow',
    component: TimePortraitSlideshow,
    meta: { hideNavbar: true }
  },
  {
    path: '/time-portrait-print',
    name: 'TimePortraitPrint',
    component: TimePortraitPrint,
    meta: { hideNavbar: true }
  },
  {
    path: '/userterms',
    name: 'UserTerms',
    component: UserTerms
  },
  {
    path: '/download',
    name: 'Download',
    component: DownloadImage,
    meta: { hideNavbar: true }
  },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isLoggedIn.value) {
    return next({ name: 'Login' })
  }
  if (to.meta.requiresManage && !userPermissions.value.enable_user_manage) {
    return next({ name: 'ImageChecker' }) // 導向其他有權限的頁面
  }
  next()
})

export default router